import { render, staticRenderFns } from "./AboutUs_EN.vue?vue&type=template&id=40af17f8&scoped=true&"
import script from "./AboutUs_EN.vue?vue&type=script&lang=js&"
export * from "./AboutUs_EN.vue?vue&type=script&lang=js&"
import style0 from "./AboutUs_EN.vue?vue&type=style&index=0&id=40af17f8&prod&lang=css&"
import style1 from "./AboutUs_EN.vue?vue&type=style&index=1&id=40af17f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40af17f8",
  null
  
)

export default component.exports